import { render, staticRenderFns } from "./ValidForm.vue?vue&type=template&id=1f324f36&scoped=true&"
import script from "./ValidForm.vue?vue&type=script&lang=js&"
export * from "./ValidForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f324f36",
  null
  
)

export default component.exports